var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AgenciesGrid',{attrs:{"params":_vm.agenciesGridParams}})}
var staticRenderFns = []

export { render, staticRenderFns }